import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import React from 'react'

import { ErrorMessage } from '../ErrorMessage'
import { RequiredSpan } from '../RequiredSpan'

import OriginalDatePicker from './DatePicker'

const defaultDate = moment()

const handleClickOutside = e => {
  e.preventDefault()
}

export class DatePicker extends React.Component {
  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  /*
   * Selected needs to be MOMENT
   * Value needs to be a string
   * Start Date needs to be a string
   *
   * Selected needs to equal the value if there is no selection -
   * Value needs to equal the selected prop if there is no value -
   * Start Date needs to equal value or selected OR defaultDate if there is no value or selected -
   *
   *
   * */

  handleChange (value) {
    const { onChange } = this.props
    onChange(value)
  }

  render () {
    const { label, value, selected, errors, required, ...rest } = this.props

    let valueString

    if (value && _.isString(value) && value.includes('_')) {
      valueString = value
    }
    if (value && _.isString(value) && !value.includes('_')) {
      valueString = moment(value).format('MM/DD/YYYY')
    }
    if (value && !_.isString(value)) {
      valueString = value.format('MM/DD/YYYY')
    }
    if (!value && selected) {
      valueString = selected.format('MM/DD/YYYY')
    }

    const className = [ 'nh-textbox' ]
    if (errors && errors.length) {
      className.push('error')
    }

    return (
      <div>
        <OriginalDatePicker
          className={className.join(' ')}
          preventFocus
          fixedHeight
          withPortal
          disableDateAutoCorrection
          onChange={this.handleChange}
          onClickOutside={handleClickOutside}
          label={label}
          startDate={valueString ? moment(valueString) : defaultDate}
          selected={selected || moment(valueString)}
          value={valueString}
          {...rest}
        />
        {required ? <RequiredSpan /> : null}
        <ErrorMessage errors={errors} />
      </div>
    )
  }
}
DatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string)
}
